import * as offlineOrderApi from "@hub/offline-order/src/api"
import createErrorMessage from "@shared/factories/src/errorMessage.factory"

export const syncOfflineSale = async data => {
  try {
    const response = await offlineOrderApi.syncOfflineSale(data)
    window.$vue.$toast({
      type: "success",
      title: response?.message || "Venda offline sincronizada com sucesso."
    })
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title:
        createErrorMessage(error).getMessage() ||
        "Falha ao sincronizar venda offline."
    })
    throw error
  }
}

export const editOfflineSale = async (id, payload) => {
  try {
    const { data } = await offlineOrderApi.editOfflineSale(id, payload)
    return data
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title:
        createErrorMessage(error).getMessage() ||
        "Falha ao editar pedido offline."
    })
    throw error
  }
}

export const getListOrder = async params => {
  try {
    const data = await offlineOrderApi.getListOfflineOrder(params)
    return data
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title:
        createErrorMessage(error).getMessage() || "Falha ao listar pedidos."
    })
    throw error
  }
}

export const getDetailsOrder = async uuid => {
  try {
    const data = await offlineOrderApi.getDetailsOrder(uuid)
    return data
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title:
        createErrorMessage(error).getMessage() ||
        "Falha ao obter detalhes do pedido."
    })
    throw error
  }
}

export const getIndicators = async params => {
  try {
    const data = await offlineOrderApi.getIndicators(params)
    return data
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title:
        createErrorMessage(error).getMessage() || "Falha ao obter indicadores."
    })
  }
}

export const cancelOfflineOrder = async uuid => {
  try {
    const data = await offlineOrderApi.cancelOfflineOrder(uuid)
    window.$vue.$toast({
      type: "success",
      title: data?.message || "Pedido cancelado com sucesso."
    })
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title:
        createErrorMessage(error).getMessage() || "Falha ao cancelar pedido."
    })
    throw error
  }
}

export const transformOfflineOrder = async uuid => {
  try {
    const data = await offlineOrderApi.transformOfflineOrder(uuid)
    window.$vue.$toast({
      type: "success",
      title: data?.message || "Pedido transformado com sucesso."
    })
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title:
        createErrorMessage(error).getMessage() || "Falha ao transformar pedido."
    })
    throw error
  }
}
